import type { Constraints, ResizeData } from '.';

interface CalculateResizeHeightOptions {
  currentHeight: number;
  constraints: Constraints;
  resizeData: ResizeData;
}

export const calculateResizeHeight = ({
  currentHeight,
  constraints: { minHeight, maxHeight },
  resizeData: { toMinHeight, toMaxHeight, movementY },
}: CalculateResizeHeightOptions): number => {
  if (toMinHeight) return minHeight;
  if (toMaxHeight) return maxHeight;

  if (typeof movementY === 'number') {
    // When dragging the resizer, allow movement that's between the constraints
    const newHeight = currentHeight + movementY;
    if (newHeight >= minHeight && newHeight <= maxHeight) {
      return newHeight;
    }
    return newHeight > maxHeight ? maxHeight : minHeight;
  }
  return currentHeight;
};

export const validateHeight = (
  initialHeight: number | null | undefined,
  minHeight: number,
  maxHeight: number
) =>
  typeof initialHeight === 'number' &&
  initialHeight >= minHeight &&
  initialHeight <= maxHeight;

export default { calculateResizeHeight, validateHeight };
